import {
  PAYMENT_TYPE_ALL,
  PAYMENT_TYPE_GET,
  PAYMENT_TYPE_DEL,
  PAYMENT_TYPE_PUT,
  PAYMENT_TYPE_POST,
  PAYMENT_TYPE_LOADING,
  PAYMENT_TYPE_ERROR,
} from '../types';

import api from '../../../configs/api';

export const paymentTypeCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_TYPE_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/payment-type`,
      {
        ...payload,
      },
    );
    dispatch({ type: PAYMENT_TYPE_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_TYPE_ERROR });
    throw new Error(error);
  }
};

export const paymentTypeAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/payment-type?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: PAYMENT_TYPE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_TYPE_ERROR });
    throw new Error(error);
  }
};

export const paymentTypeGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/payment-type/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PAYMENT_TYPE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_TYPE_ERROR });
    throw new Error(error);
  }
};

export const paymentTypeStateSet = (data) => async (dispatch) => {
  dispatch({ type: PAYMENT_TYPE_ALL, payload: data });
};

export const paymentTypePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_TYPE_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/payment-type/${id}`,
      payload,
    );
    dispatch({ type: PAYMENT_TYPE_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_TYPE_ERROR });
    throw new Error(error);
  }
};
export const paymentTypeDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_TYPE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/payment-type/${id}`,
    );
    dispatch({ type: PAYMENT_TYPE_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_TYPE_ERROR });
    throw new Error(error);
  }
};
